import { createBrandFirstSearchRequest } from "@faire/retailer-shared/categories/createRequests/createBrandFirstSearchRequest";
import { createProductFirstSearchRequest } from "@faire/retailer-shared/categories/createRequests/createProductFirstSearchRequest";
import { ISearchRequestReferrer } from "@faire/web-api/indigofair/data/ISearchRequestReferrer";
import { StrictLocalizeFunction } from "@faire/web/common/localization";
import { wrapAsyncFn } from "@faire/web/common/wrapAsyncFn";

import { ICategoryPageResults } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/ICategoryPageResults";
import { recordPerformanceMark } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/recordPerformanceMark";
import { fetchBrandFirstResults } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/useCategoryPageQuery/__internal__/fetchResults/__internal__/fetchBrandFirstResults";
import { fetchProductFirstResults } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/useCategoryPageQuery/__internal__/fetchResults/__internal__/fetchProductFirstResults";
import {
  FILTERS_TIMING_FETCH_END_KEY,
  FILTERS_TIMING_FETCH_START_KEY,
} from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/consts";

export interface ICategoryPageFetchResultsOptions {
  showProductFirstResults: boolean;
  navigationPath: string;
  filterKeys: string[];
  requestPageSize: number;
  oneIndexedPageNumber: number;
  requestReferrer: ISearchRequestReferrer;
}

export const fetchResults = async (
  {
    showProductFirstResults,
    navigationPath,
    filterKeys,
    requestPageSize,
    oneIndexedPageNumber,
    requestReferrer,
  }: ICategoryPageFetchResultsOptions,
  {
    signal,
  }: {
    signal: AbortSignal | undefined;
  },
  strictLocalize: StrictLocalizeFunction
): Promise<ICategoryPageResults> => {
  if (showProductFirstResults) {
    return fetchProductFirstResults(
      createProductFirstSearchRequest({
        navigationPath,
        filterKeys,
        requestPageSize,
        oneIndexedPageNumber,
        requestReferrer,
      }),
      {
        signal,
      }
    );
  }

  return wrapAsyncFn(
    () =>
      fetchBrandFirstResults(
        createBrandFirstSearchRequest({
          navigationPath,
          filterKeys,
          requestPageSize,
          oneIndexedPageNumber,
        }),
        {
          signal,
        },
        strictLocalize
      ),
    {
      before: () => {
        // TODO (marsohrabi): remove the performance mark after filter splitting is implemented
        // on brand-first categories
        recordPerformanceMark(FILTERS_TIMING_FETCH_START_KEY);
      },
      after: () => {
        // TODO (marsohrabi): remove the performance mark after filter splitting is implemented
        // on brand-first categories
        recordPerformanceMark(FILTERS_TIMING_FETCH_END_KEY);
      },
    }
  );
};
